import React from 'react'
import {Modal, Button, Table} from 'react-bootstrap'
import moment from 'moment'

interface Props {
  show: boolean
  docs: any[]
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
  progress?: {done: number; total: number}
}

const BatchApproveConfirmDialog: React.FC<Props> = ({
  show,
  docs,
  onConfirm,
  onCancel,
  isLoading,
  progress,
}) => {
  const pct = progress && progress.total > 0
    ? Math.round((progress.done / progress.total) * 100)
    : 0

  return (
    <Modal show={show} onHide={isLoading ? undefined : onCancel} size='lg' centered>
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>ยืนยันการอนุมัติ ({docs.length} รายการ)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className='py-4'>
            <div className='d-flex justify-content-between mb-2'>
              <span className='fw-bold'>กำลังอนุมัติ...</span>
              <span className='text-muted'>
                {progress?.done ?? 0} / {progress?.total ?? docs.length} รายการ
              </span>
            </div>
            <div className='progress' style={{height: 12}}>
              <div
                className='progress-bar progress-bar-striped progress-bar-animated'
                style={{width: `${pct}%`}}
              />
            </div>
          </div>
        ) : (
          <>
            <p className='text-muted mb-3'>รายการเอกสารที่เลือกเพื่ออนุมัติ:</p>
            <div style={{maxHeight: 400, overflowY: 'auto'}}>
              <Table bordered hover size='sm'>
                <thead className='table-light' style={{position: 'sticky', top: 0}}>
                  <tr>
                    <th>เลขที่เอกสาร</th>
                    <th>ชื่อผู้ขาย</th>
                    <th>วันที่ออก</th>
                  </tr>
                </thead>
                <tbody>
                  {docs.map((doc) => (
                    <tr key={doc.id}>
                      <td>{doc.code || '-'}</td>
                      <td>{doc.labCompany?.name || '-'}</td>
                      <td>{doc.date ? moment(doc.date).format('DD/MM/YYYY') : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onCancel} disabled={isLoading}>
          ยกเลิก
        </Button>
        <Button variant='primary' onClick={onConfirm} disabled={isLoading}>
          อนุมัติทั้งหมด
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default BatchApproveConfirmDialog
